import { IconButton, InputAdornment, Stack, styled, Typography } from '@mui/material';
import { LayoutNoAuth } from 'app/components/templates/LayoutNoAuth';
import { StyledParams } from 'types/common';
import { useInjection } from './hook';
import { InputText } from 'app/components/elements/InputText';
import { ButtonCustom, ButtonNoOutLine } from 'app/components/elements/ButtonCustom';
import { useSystemInfo } from 'contexts/systemInfo';

export const ForgotPasswordPage = () => {
  const { systemInfo } = useSystemInfo();
  const { handleSubmitForm, navigateLogin, handleSubmit, register, errors } = useInjection();
  return (
    <LayoutNoAuth>
      <Wrapper>
        <Stack pt={8.375} pb={3.5} width={'100%'} alignItems={'center'} minHeight={'100vh'}>
          <Stack
            px={{ xs: 3.125, sm: 0 }}
            mt={3}
            width={'100%'}
            maxWidth={{ xs: 'unset', sm: 402 }}>
            <Stack width={'100%'} alignItems={'center'} gap={7.25} mb={6.25}>
              {systemInfo?.logoUrl && <img alt={'logo'} width={96} src={systemInfo?.logoUrl} />}
              <Stack gap={2}>
                <TextTitleStyled>Forgot Password</TextTitleStyled>
                <TextDescStyled>
                  You will receive an email shortly with a link to reset your password.
                </TextDescStyled>
              </Stack>
            </Stack>
            <form onSubmit={handleSubmit(handleSubmitForm)}>
              <Stack gap={20.5}>
                <Stack gap={2.5}>
                  <Stack gap={1}>
                    <InputText
                      inputError={errors.email?.message}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton>
                            <img alt={'icon-user'} src={'/icons/icon_user.svg'} width={24} />
                          </IconButton>
                        </InputAdornment>
                      }
                      placeholder={'Email'}
                      inputProps={{
                        ...register('email')
                      }}
                    />
                  </Stack>
                </Stack>
                <Stack gap={3.25}>
                  <ButtonCustom type={'submit'} label={'Continue'} />
                  <ButtonNoOutLine onClick={navigateLogin} label={'Back to login'} />
                </Stack>
              </Stack>
            </form>
          </Stack>
        </Stack>
      </Wrapper>
    </LayoutNoAuth>
  );
};

const Wrapper = styled(Stack)(() => ({
  height: '100vh',
  overflowY: 'scroll'
}));
const TextTitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '32px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center'
}));
const TextDescStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center',
  width: 271
}));
